import { Chart } from 'chart.js';

export const DEFAULT_BACKGROUND_COLORS = [
  'rgba(255, 99, 132, 0.65)',
  'rgba(54, 162, 235, 0.65)',
  'rgba(255, 206, 86, 0.65)',
  'rgba(75, 192, 192, 0.65)',
  'rgba(153, 102, 255,0.65)',
  'rgba(255, 159, 64, 0.65)',
  'rgba(74, 57, 51, 0.65)',
  'rgba(247, 89, 171, 0.65)',
  'rgba(255, 70, 70, 0.65)',
  'rgba(109, 220, 207, 0.65)',
  'rgba(240, 195, 142, 0.9)',
  'rgba(72, 66, 109, 0.65)',
];

export const DEFAULT_BORDER_COLORS = [
  'rgba(255, 99, 132, 1)',
  'rgba(54, 162, 235, 1)',
  'rgba(255, 206, 86, 1)',
  'rgba(75, 192, 192, 1)',
  'rgba(153, 102, 255, 1)',
  'rgba(255, 159, 64, 1)',
  'rgba(74, 57, 51, 1)',
  'rgba(247, 89, 171, 1)',
  'rgba(255, 70, 70, 1)',
  'rgba(109, 220, 207, 1)',
  'rgba(240, 195, 142, 1)',
  'rgba(72, 66, 109, 1)',
]

export interface SimpleChartOption {
  labels: string[];
  values: number[];
  title?: string;
  type?: string;
  min?: number;
  max?: number;
  step?: number;
  beginAtZero?: boolean;
  backgroundColor?: string | string[];
  borderColor?: string | string[];
  tooltipCallback?: (tooltipItems: any, data: any) => string;
  displayY?: boolean;
  datasetLabel?: string;
}

const simpleChart = (id: string, options: SimpleChartOption) => {
  const context = document.getElementById(id) as HTMLCanvasElement;
  if (context == null) {
    throw new Error(`chartjs::simpleChart => Element with id ${id} not found.`);
  }
  const type = options.type ?? 'bar';
  const chart = new Chart(context, {
    type: type as any,
    data: {
      labels: options.labels,
      datasets: [
        {
          label: options.datasetLabel,
          data: options.values,
          backgroundColor: options.backgroundColor ?? DEFAULT_BACKGROUND_COLORS,
          borderColor: options.borderColor ?? DEFAULT_BORDER_COLORS
        }
      ]
    },
    options: {
      title: {
        display: options.title ? true : false,
        text: options.title
      },
      scales: {
        yAxes: [{
          display: options.displayY ?? true,
          ticks: {
            suggestedMin: options.min,
            suggestedMax: options.max,
            stepSize: options.step ?? 1,
            beginAtZero: options.beginAtZero ?? true,
          }
        }],
      },
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: options.tooltipCallback ?? ((tooltip: any, data: any) => {
            let text = data.labels[tooltip.index] + ': ';
            text += data.datasets[tooltip.datasetIndex].data[tooltip.index] + ' ';
            return text;
          })
        }
      }
    }
  });
  return chart;
}

export default simpleChart;
